import { PortalFieldConfig } from '@portal/form/data-access';

export function maxSelectFileValidatorMessage(error: unknown, field: PortalFieldConfig): string {
  return `Upload quantity exceeds maximum value!`;
}

export function maxSizeFileValidatorMessage(error: unknown, field: PortalFieldConfig): string {
  return `File is too large`;
}

export function minSizeFileValidatorMessage(error: unknown, field: PortalFieldConfig): string {
  const minSizeFile = field.props?.min || 10;
  return `Upload unsuccessfully. Please upload a new file that is more than ${minSizeFile} bytes.`;
}

export function fileNameValidatorMessage(error: unknown, field: PortalFieldConfig): string {
  return `File names are allowed to contain only the following characters: !-_.*'()&$@=;:+,?. Additionally, file names must be a maximum of 150 characters long.`;
}
